module.exports = __webpack_public_path__ + "media/images/sample-51a69d82aa99699639d27fd388757a82.png";